<div class="d-flex flex-column campaign-influencers-items" *ngIf="isShow"
    [ngClass]="{'campaign-influencers-items-overview': isCampaignInfluencerDetails && !isCampaignDetails}">
  <div class="d-flex flex-g1 campaigns-influencers-header">
    <div class="d-flex flex-row flex-auto flex-nowrap">
      <div class="d-flex header-small-title align-items-center campaign-influencer-info">
      </div>
      <div class="d-flex header-small-title align-items-center justify-content-start campaign-influencer-status">
        <span class="status-header">{{'campaigns.status' | translate}}</span>
        <achoo-icon-tooltip [tooltipMsg]="'info_box.campaign.status_col' | translate"></achoo-icon-tooltip>
      </div>
      <div class="d-flex header-small-title align-items-center campaign-influencer-posts-platforms">
        <div class="d-flex flex-row flex-auto">
          <div class="d-flex flex-g1 justify-content-start campaign-influencer-posts">
            <span class="post-header">{{'campaigns.posts' | translate}}</span>
          </div>
          <div class="d-flex flex-g3 justify-content-start campaign-influencer-platforms">
            <span class="platforms-header">{{'campaigns.platforms' | translate}}</span>
          </div>
        </div>
      </div>
      <div class="d-flex header-kpi align-items-center justify-content-start campaign-influencer-reach">
        <span class="reach-header">{{'campaigns.reach' | translate}}</span>
      </div>
      <div class="d-flex header-kpi align-items-center justify-content-start campaign-influencer-engagement">
        <span class="engagement-header">{{'campaigns.engagement' | translate}}</span>
      </div>
      <div class="d-flex header-kpi align-items-center justify-content-start campaign-influencer-impact-percent">
        <span class="impact-header">{{'campaigns.impact' | translate}}</span>
      </div>
      <div class="d-flex header-kpi align-items-center campaign-influencer-button">
      </div>
    </div>
  </div>
  <div class="d-flex flex-g1 campaign-border-bottom"></div>
  <div *ngFor="let influencer of influencerList; let isLastItem = last">
    <campaign-influencers-item 
      [isCampaignDetails]="isCampaignDetails"
      [campaignId]="campaignId"
      [influencer]="influencer"
      [isLastItem]="isLastItem">
    </campaign-influencers-item>
  </div>
  <div *ngIf="influencerList?.length === 0">
    <p>{{emptyListMessage}}</p>
  </div>
  <button *ngIf="isCampaignInfluencerDetails && !isCampaignDetails" class="button gray" (click)="viewAllInfluencer()">{{'campaigns.view_all_influencer' | translate}}</button>
</div>



// WEBPACK FOOTER //
// ./src/app/main/campaigns/campaign-influencers-list/campaign-influencers-list.component.html